import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrintApiService  {
  public uriPrint: string;
  public uriDrv: string;
  public uriRetrofit: string;
  private pdfContentType = new HttpHeaders({'Accept':'application/pdf'})

  constructor(
    private http: HttpClient
  ) {
    if (window['ebbApi']) {
      this.uriPrint = `${window['ebbApi']}/PrintApplication/Print`;
      this.uriDrv = `${window['ebbApi']}/PrintApplication/Drv`;
      this.uriRetrofit = `${window['ebbApi']}/PrintApplication/RetrofitVerification`;
    } else {
        this.uriPrint = `https://${environment.devBaseUrl}/api/PrintApplication/Print`;
        this.uriDrv = `https://${environment.devBaseUrl}/api/PrintApplication/Drv`;
        this.uriRetrofit = `https://${environment.devBaseUrl}/api/PrintApplication/RetrofitVerification`;
    }
  }

  public getPrint(appId: string, statusSuffix: string): Observable<Blob> {
    return this.http.get(`${this.uriPrint}?applicationid=${appId}&statusSuffix=${statusSuffix}`, { headers: this.pdfContentType, withCredentials: true, responseType: 'blob'})
    .pipe(map(res => {
      return new Blob([res], { type: 'application/pdf', });
    }));
  }

  public getDrv(appId: string): Observable<Blob> {
    return this.http.get(`${this.uriDrv}?applicationid=${appId}`, { headers: this.pdfContentType, withCredentials: true, responseType: 'blob'})
    .pipe(map(res => {
      return new Blob([res], { type: 'application/pdf', });
    }));
  }

  public getRetrofitVerification(appId: string): Observable<Blob> {
    return this.http.get(`${this.uriRetrofit}?applicationid=${appId}`, { headers: this.pdfContentType, withCredentials: true, responseType: 'blob'})
    .pipe(map(res => {
      return new Blob([res], { type: 'application/pdf', });
    }));
  }
}
